export const tr = {
    experimentsArchive: '{experimentsArchiveName} - arşiv'
};
